// import DateTime from 'luxon/src/datetime';
import { DateTime } from "luxon";

export default {
    // 2022-10-26 16:01:15
    // yyyy-LL-dd hh:mm:ss
    formatDateTime(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd hh:mm:ss");
        return fromFormat.toLocaleString(DateTime.DATETIME_MED);
    },
    // 2022-10-26T16:01:15.0000
    // yyyy-LL-dd hh:mm:ss
    formatDateTimeV2(date) {
        if (!date) return;
        const formattedData = date.replace("T", " ").split(".")[0];
        const fromFormat = DateTime.fromFormat(
            formattedData,
            "yyyy-LL-dd hh:mm:ss"
        );
        return fromFormat.toLocaleString(DateTime.DATETIME_MED);
    },
    // 2022-10-26
    // yyyy-LL-dd
    formatDate(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd");
        return fromFormat.toLocaleString(DateTime.DATE_FULL);
    },
    // Tue Nov 01 2022 00:00:00 GMT+0800 (Philippine Standard Time)
    // yyyy-LL-dd or yyyy-LL-dd hh:mm:ss
    formatFromPST(date, time = false) {
        if (!date) return;
        if (time)
            return DateTime.fromJSDate(date).toFormat("yyyy-LL-dd hh:mm:ss");
        else return DateTime.fromJSDate(date).toFormat("yyyy-LL-dd");
    },
    // yyyy-LL-dd
    // Tue Nov 01 2022 00:00:00 GMT+0800 (Philippine Standard Time)
    formatToPST(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd");
        return fromFormat.toJSDate();
    },
    // Oct 14, 1983
    // yyyy-LL-dd
    formatFromDateMed(date) {
        if (!date) return;
        // Try ISO first
        let dt;
        if (typeof date === "string") {
            // If date is like "2025-12-05" (yyyy-LL-dd)
            dt = DateTime.fromFormat(date, "yyyy-LL-dd");
            // fallback: try ISO
            if (!dt.isValid) dt = DateTime.fromISO(date);
        } else if (date instanceof Date) {
            dt = DateTime.fromJSDate(date);
        }
        if (!dt || !dt.isValid) return;
        return dt.toFormat("LLL dd, yyyy"); // Dec 05, 2025
    },
    formatFromDateMedTime(date) {
        if (!date) return

        let dt

        if (typeof date === "string") {
            // Try datetime first (e.g. 2025-12-05 15:30 or ISO)
            dt = DateTime.fromISO(date)

            // fallback: date only
            if (!dt.isValid) {
            dt = DateTime.fromFormat(date, "yyyy-LL-dd")
            }
        } else if (date instanceof Date) {
            dt = DateTime.fromJSDate(date)
        }

        if (!dt || !dt.isValid) return

        return dt.toFormat("LLL dd, yyyy, hh:mm a")
    },

    // Date now
    // Jan 19, 2023, 5_23 PM
    exportExcelDate() {
        return DateTime.fromISO(DateTime.utc().toISO()).toFormat("ff");
    },

	formatTimeOnly(date) {
        if (!date) return;

        let dt;

        if (date instanceof Date) {
            dt = DateTime.fromJSDate(date);
        } else {
            // If it's a string like "Fri Dec 19 2025 02:00:00 GMT+0800"
            dt = DateTime.fromJSDate(new Date(date));
        }

        if (!dt.isValid) return;

        return dt.toFormat("HH:mm:ss"); // 24-hour format with seconds
	},
    
    generateDateTimeFromTime(timeString) {
        if (!timeString) return null;

        // Split the time string into hours, minutes, seconds
        const [hour, minute, second] = timeString.split(':').map(Number);

        // Use today's date with the given time
        const dt = DateTime.local().set({
            hour,
            minute,
            second,
            millisecond: 0
        });

        return dt.toJSDate(); // returns a JavaScript Date object
    }

};
